import { PieChart } from "@mui/x-charts/PieChart";
import { Typography, Box } from "@mui/material";

export const valueFormatter = (item) => `${item.value}`;

export default function Chart({
  chartData = [],
  colors = [],
  ishidden = false,
}) {
  // Prepare legend items with percentage
  const legendItems = chartData.map((item, idx) => ({
    label: item.label,
    value: item.value,
    color: colors[idx % colors.length],
  }));

  return (
    <Box sx={{ width: "inherit", display: "flex", justifyContent: "flex-end" }}>
      <PieChart
        colors={colors}
        height={185}
        width={430}
        series={[
          {
            data: chartData,
            innerRadius: 70,
            outerRadius: 130,
            arcLabel: () => "", // Hide label on chart
            arcLabelRadius: "80%",
            arcLabelMinAngle: 5,
            valueFormatter,
            cx: 150,
            cy: 100,
          },
        ]}
        slotProps={{
          legend: {
            hidden: true, // Hide default legend
          },
        }}
      />
      {/* Custom legend with percentage */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          minWidth: 145,
          maxHeight: 120, // Set a max height for the legend box
          overflowY: "auto", // Enable vertical scrolling if content overflows
        }}
      >
        {legendItems.map((item, idx) => (
          <Box
            key={item.label}
            sx={{ display: "flex", alignItems: "center", mb: 1 }}
          >
            <Box
              sx={{
                width: 12,
                height: 12,
                backgroundColor: item.color,
                marginRight: 1,
                border: "1px solid #ccc",
              }}
            />
            <Typography variant="caption">
              {item.label} - {item.value}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
